<template>
  <div class="homePage">
    <div class="exhibitor">
      <div class="title">
        <h3>{{ $t('homepage.exhibitor') }}</h3>
        <button @click="editExhi">{{ $t('homepage.editexhibitor') }}</button>
      </div>
      <div class="content">
        <div class="img">
          <img v-if="company.comCover" :src="`${company.comCover.includes('https')?'':imgbaseUrl}${company.comCover}`" alt="" />
          <img v-else alt="" src="../../../static/logo_default.png" />
        </div>
        <div class="detail">
          <p style="font-weight:600;font-size:4.3vw">{{ company.companyNameC }}</p>
          <div class="fontStyle">
            <p>
              {{ $t('homepage.pavilion') }}：<i style="color: #333333">{{ addcomma(boothList.boothName) }}</i>
            </p>

            <p>
              {{ $t('homepage.positionNumber') }}：<i style="color: #333333">{{ addcomma(boothList.boothNum) }}</i>
            </p>
          </div>

          <div>
            <p style="font-size: 14px;">{{ $t('homepage.boothType') }}：{{ boothList.bootTypeName[0] }}</p>
            <p class="lastSpan" v-show="boothList.boothArea.length !== 0">{{ $t('homepage.boothArea') }}：{{ addcomma(boothList.boothArea) }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 六个盒子 -->
    <div class="productBox">
      <div class="box1" @click="enterPage('1')">
        <img src="../../../static/图片看展icon.png" alt="图片看展" />
        <div class="text">
          <p v-if="lang == 'zh'">{{ $t('common.imgView') }}</p>
          <p class="miaoshu">({{ $t('common.uploadImg') }})</p>
        </div>
      </div>
      <div class="box1 box2" @click="enterPage('2')">
        <img src="../../../static/视频看展icon.png" alt="视频看展" />
        <div class="text">
          <p v-if="lang == 'zh'">{{ $t('common.videoView') }}</p>
          <p class="miaoshu">({{ $t('common.uploadVideo') }})</p>
        </div>
      </div>
      <div class="box1 box2" @click="enterPage('Download')">
        <img src="../../../static/下载中心icon.png" alt="下载中心" />
        <div class="text">
          <p>{{ $t('navbar.download') }}</p>
        </div>
      </div>
      <div class="box1" @click="enterPage('Connection')">
        <img src="../../../static/联系我们icon.png" alt="联系我们" />
        <div class="text">
          <p>{{ $t('navbar.connection') }}</p>
        </div>
      </div>
      <div class="box1" @click="enterPage('mineMessage')">
        <img src="../../../static/我的消息icon.png" alt="我的消息" />
        <div class="text">
          <p>{{ $t('homepage.message') }}</p>
        </div>
      </div>

      <div class="box1 box2" @click="enterPage('wxInvite')">
        <img src="../../../static/微信.png" alt="下载中心" />
        <div class="text">
          <p>{{ $t('navbar.wx') }}</p>
        </div>
      </div>
    </div>
    <footBottom />
  </div>
</template>

<script>
import { getExhition } from '../../../../api/exhibitor';
import { logout } from '../../../../api/login.js';
import { forMat, backExhibitionList } from '../../../../utils/common';
import MobileHead from '../../comment/mobile/mobileHead.vue';
import footBottom from '../../comment/mobile/footMobile.vue';
import config from '../../../../config';
import { perfix } from '../../../../utils/common';
import { VRLogin } from "../../../../utils/way.js";  //导入VR登录处理函数
export default {
  data() {
    return {
      //展商信息
      company: [],
      imgbaseUrl: forMat(),
      //展位信息
      boothList: {
        boothName: [], //展馆
        boothNum: [], //展位号
        bootTypeName: [], //展位类型
        boothArea: [], //展位面积
      },
      //VR上传资料相关的视频和图片地址
      VrUploadData: {
        uploadImg: config.vrUploadImg,
        uploadVideo: config.vrUploadVideo,
      },
      lang: '',
      mobile: '',
    };
  },

  components: {
    MobileHead,
    footBottom,
  },

  computed: {},
  created() {
    this.mobile = perfix();
    this.getExhition();
    this.lang = localStorage.getItem('lang');

    if (this.mobile) {
      this.VrUploadData.uploadImg = config.vruploadURL;
      this.VrUploadData.uploadVideo = config.vruploadURL;
    } else {
      window.location.href = this.VrUploadData.uploadImg;
      window.location.href = this.VrUploadData.uploadVideo;
    }
  },

  methods: {
    async getExhition() {
      try {
        let { data } = await getExhition();
        this.company = data.data;
        this.boothList = {
          boothName: [], //展馆
          boothNum: [], //展位号
          bootTypeName: [], //展位类型
          boothArea: [], //展位面积
        };
        //如果展位信息为无
        if (this.company.hzBoothList.length === 0 || typeof this.company.hzBoothList === 'undefined') {
          return (this.boothList = {
            boothName: ['无'], //展馆
            boothNum: ['无'], //展位号
            bootTypeName: ['无'], //展位类型
            boothArea: [], //展位面积 不显示
          });
        }
        // 如果有展位信息
        if (this.company.hzBoothList.length > 0) {
          this.company.hzBoothList.forEach((item, index) => {
            this.boothList.boothName.push(item.boothName);
            this.boothList.boothNum.push(item.boothNum);
            this.boothList.bootTypeName.push(item.bootTypeName);
            this.boothList.boothArea.push(item.boothArea + 'm²');
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    addcomma(arr) {
      return arr.join('、');
    },
    editExhi() {
      this.$router.push('/backIndex/exhiIndex');
    },

    //路由处理函数
    enterPage(path) {
      if (path == '1') {
         //拿到展商Id
        const exId = localStorage.getItem("exid");
        this.entryVr(exId, config.vruploadURL);  //VR同步登录,并且执行函数进行跳转
      }
      if (path == '2') {
         const exId = localStorage.getItem("exid");
        this.entryVr(exId, config.vruploadURL); //VR同步登录,并且执行函数进行跳转
      }
      if (path !== '1' && path !== '2') {
        this.$router.push({
          name: path,
        });
      }
    },

   //调用VR同步登录函数
    entryVr(id, url) {
      const exId = id; //展商Id
      const uploadUrl = url;
      let that = this;
      if (that.VrLoginFlag) return; //阶段多次误发请求
      //拿到展商Id，且展商Id是正确的，才进行脚本请求
      if (typeof exId == "string" && exId.length >= 15) {
        const that = this;
        const VrLoginData = { ...VRLogin(exId, that) };
        var scriptNode = document.createElement("script");
        scriptNode.type = "text/javascript";
        scriptNode.src = `${config.vrUrl}/ckjump/login?hzExhibitor_id=${VrLoginData.hzExhibitor_id}&sign=${VrLoginData.sign}&time=${VrLoginData.time}&url=${uploadUrl}`;
        document.getElementsByTagName("head")[0].appendChild(scriptNode);
        document.getElementsByTagName("head")[0].removeChild(scriptNode); //清除创建多余的dom节点.避免污染
        that.VrLoginFlag = true;
        //远程脚本请求完后才能进行跳转
        scriptNode.onload = function() {
          that.VrLoginFlag = false; //解锁
          var a = document.createElement("a");
          a.href = uploadUrl;
          a.setAttribute("target", "_blank");
          a.click();
        };
      }
    },


  },
};
</script>
<style lang="scss" scoped>
.homePage {
  width: 100vw;
  box-sizing: border-box;
  // border: 1px solid red;
  padding: 2.6vw 2.6vw 0 2.6vw;
  background: #f0f2f5;
  .exhibitor {
    width: 94.6vw;
    margin: 0 0 2.6vw 0;
    box-sizing: border-box;
    //  padding: 10px;
    //  border: 1px solid red;
    // padding: 17px 26px 26px 0;
    background: white;
    // border: 1px solid red;
    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 5.3vw 4vw 9px 15px;
      font-size: 4.5vw;
      border-bottom: 1px solid #e9e9e9;

      button {
        width: 24vw;
        height: 8.5vw;
        border: none;
        background: #006fb8;
        color: white;
        border-radius: 4px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 17px 26px 25px 15px;

      .img {
        width: 192px;
        height: 108px;
        text-align: center;
        margin-right: 30px;
        margin-bottom: 4vw;

        img {
          max-width: 192px;
          max-height: 108px;
        }
      }

      .detail {
        // border: 1px solid red;
        width: 88%;
        p:first-child {
          margin-bottom: 2.6vw;
        }
        .fontStyle {
          p {
            font-size: 14px;
          }
        }
        div i {
          line-height: 18px;
          // display: flex;
          font-size: 3.7vw;
          font-family: PingFangSC-Medium, PingFang SC;
          font-style: normal !important;
          font-weight: 500;
          color: #333333;
        }

        div:last-child {
          margin-top: 10px;
          .lastSpan {
            // width: ;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 14px;
          }
        }

        span {
          display: inline-block;
          width: 50%;
          font-size: 14px;

          white-space: nowrap;

          i {
            font-style: normal;
            font-size: 17px;
            margin-top: 5px;
            display: inline-block;
            width: 72%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .productBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 4vm;
    .box1 {
      width: 46vw;
      box-sizing: border-box;

      height: 20.53vw;
      margin-bottom: 2.6vw;
      padding: 4.8vw 2.8vw 2vw 7.2vw;
      display: flex;
      background: url('../../../static/blueBG.png');
      // background: #fff;
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      // line-height: 45px;
      .text {
        margin-left: 4vw;
        .miaoshu {
          font-size: 3.2vw;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.7);
          word-break: break-all;
        }
        p {
          margin-top: 5px;
        }
      }
      img {
        width: 9.3vw;
        height: 9.3vw;
      }
    }
    .box2 {
      background: url('../../../static/yellowBG.png');
      // background: #fff;
      // color: #006fb8;
      // font-size: 2.1vw;
      // font-family: PingFangSC-Medium, PingFang SC;
      // font-weight: 500;
      // color: #333333;
      // line-height: 3.1vw;
    }
  }
}
</style>
